angular.module('app').component('uiGwStop', {
    templateUrl: 'js/components/ui-gw-stop/index.html',
    controller: UiGwStopController,
    controllerAs: '$ugs',
    bindings: {
        api: '<',
    },
});

UiGwStopController.$inject = ['$http'];

function UiGwStopController($http) {
    var $ctrl = this;

    $ctrl.TAB_MAIN = 1;
    $ctrl.TAB_CAN = 2;
    $ctrl.can = null;

    $ctrl.dismiss = dismiss;
    $ctrl.isTab = isTab;
    $ctrl.changeTab = changeTab;

    $ctrl.$onInit = function() {
        if ($ctrl.api === void 0) {
            return;
        }
        $ctrl.can = null;
    };

    $ctrl.$doCheck = function() {
        if ($ctrl.api === void 0) {
            return;
        }

        if (!angular.equals(storedCoords, $ctrl.api.data.coords)) {
            onCoordsChange($ctrl.api.data.coords);
        }
        storedCoords = angular.copy($ctrl.api.data.coords);
    };

    var tab = $ctrl.TAB_MAIN;
    var storedCoords = null;

    function isTab(t) {
        return tab === t;
    }

    function changeTab(t) {
        tab = t;
        if (tab === $ctrl.TAB_CAN) {
            getCanData();
        }
        $ctrl.api.on.resize();
    }

    function getCanData() {
        var object = $ctrl.api.data.object;
        var stop = $ctrl.api.data.stop;

        var endpoint = `/api-react/object/${object.id}/module/can?id=${stop.model.messageId}`;

        return $http.get(endpoint).then(function(response) {
            $ctrl.can = response.data.data;
            $ctrl.api.on.resize();

            return $ctrl.can;
        });
    }

    function reset() {
        $ctrl.can = null;
        $ctrl.changeTab($ctrl.TAB_MAIN);
    }

    function onCoordsChange(coords) {
        if (typeof $ctrl.api.on.coordsChange === 'function') {
            reset();
            $ctrl.api.on.coordsChange(coords);
        }
    }

    function dismiss() {
        $ctrl.api.fn.close();
    }
}
